import React, { useState } from 'react';
import { config } from '../config';

const AdminAccess = () => {
  const [showAdminPanel, setShowAdminPanel] = useState(false);
  const [adminCode, setAdminCode] = useState('');

  const handleAdminAccess = () => {
    if (adminCode === config.ADMIN_PASSWORD) {
      window.open(config.DASHBOARD_URL, '_blank');
    } else {
      alert('Invalid admin code');
    }
  };

  // Hidden keyboard shortcut to show admin panel (Ctrl+Shift+A)
  React.useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.ctrlKey && e.shiftKey && e.key === 'A') {
        setShowAdminPanel(true);
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);

  if (!showAdminPanel) return null;

  return (
    <div className="fixed bottom-4 right-4 bg-gray-900 p-4 rounded-lg shadow-lg z-50 border border-gray-700">
      <div className="text-white text-sm mb-2">Admin Access</div>
      <div className="flex space-x-2">
        <input
          type="password"
          placeholder="Admin code"
          value={adminCode}
          onChange={(e) => setAdminCode(e.target.value)}
          className="px-2 py-1 text-sm rounded bg-gray-800 text-white border border-gray-600"
          onKeyPress={(e) => e.key === 'Enter' && handleAdminAccess()}
        />
        <button
          onClick={handleAdminAccess}
          className="px-3 py-1 bg-purple-600 text-white text-sm rounded hover:bg-purple-700"
        >
          Access
        </button>
        <button
          onClick={() => setShowAdminPanel(false)}
          className="px-2 py-1 bg-gray-600 text-white text-sm rounded hover:bg-gray-700"
        >
          ×
        </button>
      </div>
      <div className="text-xs text-gray-400 mt-2">
        Dashboard: <a href={config.DASHBOARD_URL} target="_blank" rel="noopener noreferrer" className="text-purple-400 hover:underline">View Signups</a>
      </div>
    </div>
  );
};

export default AdminAccess; 
